var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -8,
    y: -12,
    width: 110,
    height: 111
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(8px)",
      clipPath: "url(#bgblur_0_996_6892_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_996_6892)",
    "data-figma-bg-blur-radius": 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 29C8 15.1929 19.1929 4 33 4H61C74.8071 4 86 15.1929 86 29V58C86 71.8071 74.8071 83 61 83H33C19.1929 83 8 71.8071 8 58V29Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 4.5H61C74.531 4.5 85.5 15.469 85.5 29V58C85.5 71.531 74.531 82.5 61 82.5H33C19.469 82.5 8.5 71.531 8.5 58V29C8.5 15.469 19.469 4.5 33 4.5Z",
    stroke: "black",
    strokeOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_996_6892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3282 54.9047C35.131 55.8109 35.8268 56.1946 36.4724 55.9051L58.2922 44.7167H58.2944C58.5547 44.5699 58.7058 44.3054 58.7058 44.0003C58.7058 43.6949 58.5547 43.4302 58.2944 43.2835H58.2922L36.4724 32.0949C35.8268 31.8054 35.131 32.1892 35.3282 33.0954C35.3416 33.1568 36.6316 38.9029 37.3329 42.0279L48.7232 44.0002L37.3329 45.9722C36.6316 49.0971 35.3415 54.8433 35.3282 54.9047Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_996_6892",
    x: -8,
    y: -12,
    width: 110,
    height: 111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.105882 0 0 0 0 0.105882 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_996_6892"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_996_6892",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_996_6892_clip_path",
    transform: "translate(8 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 29C8 15.1929 19.1929 4 33 4H61C74.8071 4 86 15.1929 86 29V58C86 71.8071 74.8071 83 61 83H33C19.1929 83 8 71.8071 8 58V29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_996_6892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(35 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButton);
export default __webpack_public_path__ + "static/media/Send Button.3197d0020144c2fbfbe8056cd193cef1.svg";
export { ForwardRef as ReactComponent };